import type { StepRange } from "../../../api/generated/model";

/** A slider's values, min to max by its step, as live's selects list them. */
export function stepsOf(range: StepRange): number[] {
  const count = Math.round((range.max - range.min) / range.step) + 1;
  return Array.from({ length: count }, (_, at) => round(range.min + at * range.step));
}

/** Two decimals at most: 0.1 + 0.2 is 0.3 here. */
export function round(value: number): number {
  return Math.round(value * 100) / 100;
}
